const indexItems = [
  { title: "明星黑料", count: 128, icon: "ri-star-line", color: "text-primary-400" },
  { title: "网红翻车", count: 96, icon: "ri-live-line", color: "text-accent-400" },
  { title: "综艺内幕", count: 73, icon: "ri-tv-line", color: "text-primary-400" },
  { title: "带货打假", count: 85, icon: "ri-shopping-bag-line", color: "text-accent-400" },
  { title: "选秀黑幕", count: 42, icon: "ri-mic-line", color: "text-primary-400" },
  { title: "品牌虚假宣传", count: 61, icon: "ri-advertisement-line", color: "text-accent-400" },
  { title: "感情纠纷", count: 109, icon: "ri-heart-line", color: "text-primary-400" },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 text-center mb-4">
          爆料主题索引
        </h2>
        <div className="w-16 h-1 bg-accent-500 mx-auto mb-10 rounded-full"></div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg p-4 text-center border border-background-200/50 hover:border-primary-500/30 transition-colors cursor-pointer group"
            >
              <div className={`w-10 h-10 flex items-center justify-center mx-auto mb-2`}>
                <i className={`${item.icon} text-2xl ${item.color}`}></i>
              </div>
              <h3 className="text-foreground-300 text-xs mb-1 group-hover:text-foreground-100 transition-colors whitespace-nowrap">
                {item.title}
              </h3>
              <span className="text-foreground-600 text-xs">{item.count} 篇</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}